module.exports = __webpack_public_path__ + "img/LoginCard-left-old.1c86883c.png";